import React from 'react';
import config from '../../config/config'
import branding from '../../config/branding'
import PropTypes from 'prop-types'
import { useHistory } from "react-router-dom";

import './header.scss'

export default function Header(props) {

  const history = useHistory()

  const onClick = (id) => {

    const path = '/' + id

    history.push(path)
  }

  const renderHeader = () => {

    const brand = branding[config.brandId]

    const logo = brand.logo ? config.getImage(brand.logo) : null
    const mobilelogo = brand.mobilelogo ? config.getImage(brand.mobilelogo) : null

    return <div className='cochlear-header'>

            {logo && (
              <div className="desktop-header">
                <a href="#top" rel="noopener noreferrer">
                  <img className='text-left' src={logo} alt='logo' />
                </a>
              </div>
            )}

            {mobilelogo && (
              <div className="mobile-header">
                <a href="#top" rel="noopener noreferrer" >
                  <img className='text-left' src={mobilelogo} alt='logo' />
                </a>
              </div>
            )}

            {
              config.devMode?

              <div className="hide-desktop">
                <button type="button" className='btn  text-right' onClick={onClick.bind(this, 'practice')}>Practice</button>
                <button type="button" className='btn  text-right' onClick={onClick.bind(this, 'test')}>Test</button>
                <button type="button" className='btn  text-right' onClick={onClick.bind(this, 'result')}>Result</button>
              </div>

              :
                null
            }

          </div>
    }

    return <header className="app-header row">
              {renderHeader()}
            </header>
}

Header.propTypes = {
  onHeaderClick: PropTypes.func
}